import { Link, useLocation } from 'react-router-dom';
import { Home, Users, Briefcase, Mail } from 'lucide-react';

const navItems = [
  { name: 'About', path: '/about', icon: Users },
  { name: 'Services', path: '/services', icon: Briefcase },
  { name: 'Results', path: '/case-results', icon: Home },
  { name: 'Book Call', path: '/contact', icon: Mail },
];

export default function MobileBottomNav() {
  const location = useLocation();

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 safe-area-bottom">
      <div className="grid grid-cols-4 gap-0">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <Link
              key={item.name}
              to={item.path}
              className={`flex flex-col items-center justify-center py-3 px-1 text-xs font-medium transition-colors ${
                isActive
                  ? 'text-accent-600 bg-accent-600/5'
                  : 'text-slate-500 hover:text-slate-900'
              }`}
            >
              <item.icon className="w-5 h-5 mb-1" />
              <span>{item.name}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
